import {
  ADD_USER_TO_CONVERSATION_LIST,
  ON_CHANGE_CONVERSATION,
  ON_DISPLAY_DETAIL_CONTACT,
  ON_DISPLAY_MODAL_USERS,
  ON_LOAD_MESSAGE_LIST,
  ON_LOAD_MESSAGE_LIST_FAILED,
  ON_LOAD_MESSAGE_LIST_SUCCESS,
  ON_LOAD_USER_CONVERSATION_LIST,
  ON_LOAD_USER_CONVERSATION_LIST_FAILED,
  ON_LOAD_USER_CONVERSATION_LIST_SUCCESS,
  ON_RESET_USER_CONVERSATION,
} from './constants';

export const onDisplayModalUsers = (status) => ({
  type: ON_DISPLAY_MODAL_USERS,
  payload: { status },
});

export const onDisplayDetailContact = (status) => ({
  type: ON_DISPLAY_DETAIL_CONTACT,
  payload: { status },
});

export const onAddUserToConversationList = (user) => ({
  type: ADD_USER_TO_CONVERSATION_LIST,
  payload: { user },
});

export const onChangeConversation = (user, id) => ({
  type: ON_CHANGE_CONVERSATION,
  payload: { user, id },
});

export const onResetUserConversation = () => ({
  type: ON_RESET_USER_CONVERSATION,
});

export const onLoadMessageList = (messages, cognitoId, activeUserConversation) => ({
  type: ON_LOAD_MESSAGE_LIST,
  payload: { messages, cognitoId, activeUserConversation },
});

export const onLoadMessageListSuccess = (messages) => ({
  type: ON_LOAD_MESSAGE_LIST_SUCCESS,
  payload: { messages },
});

export const onLoadMessageListFailed = (error) => ({
  type: ON_LOAD_MESSAGE_LIST_FAILED,
  payload: { error },
});

export const onLoadUserConversationList = (messages, cognitoId, users) => ({
  type: ON_LOAD_USER_CONVERSATION_LIST,
  payload: { messages, cognitoId, users },
});

export const onLoadUserConversationListSuccess = (userList) => ({
  type: ON_LOAD_USER_CONVERSATION_LIST_SUCCESS,
  payload: { userList },
});

export const onLoadUserConversationListFailed = (error) => ({
  type: ON_LOAD_USER_CONVERSATION_LIST_FAILED,
  payload: { error },
});
